import React, { useState, useEffect } from 'react'

import { useProject } from 'hooks'

import Editor from './Editor'

import './RulesForm.scss'

export default function RulesForm() {
  const { project, updateProjectPart, canEdit } = useProject()
  const [rules, setRules] = useState(project?.rules || [])
  const [shouldSave, setShouldSave] = useState(false)

  const onSave = content => {
    setShouldSave(true)
    setRules(content)
  }

  useEffect(() => {
    if (rules && shouldSave) updateProjectPart('rules', rules)
  }, [rules, shouldSave])

  return (
    <div className='rules-form'>
      <Editor properties={rules} onSave={onSave} disabled={!canEdit} />
    </div>
  )
}
